
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/press/[slug]",
      function () {
        return require("private-next-pages/media/press/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/press/[slug]"])
      });
    }
  